import React from "react";
import { bindActionCreators } from "redux";
import RegistrationPage from "../../components/Auth/RegistrationPage";
import { connect } from "react-redux";
import { getIsUserLoading, fetchCreateUser, getError } from "../../reducers/user";
import { getIsLoginLoading } from "../../reducers/login";

const RegistrationContainer = props => <RegistrationPage {...props} />;

const mapState = (state, props) => ({
  isLoading: getIsUserLoading(state) || getIsLoginLoading(state),
  error: getError(state)
});

const actions = (dispatch, props) => ({
  createUser: bindActionCreators(fetchCreateUser, dispatch),
});

export default connect(mapState, actions)(RegistrationContainer);
